/**
 * ========================================
 * CHATBOT CONFIGURATION
 * Centralized configuration for the chatbot widget
 * ========================================
 */
(function () {
    'use strict';

    // Environment-specific configuration
    const API_BASE_URL = "https://codeskin-service-625951850094.asia-south1.run.app";

    const CONFIG = {
        // API Endpoints
        ENDPOINTS: {
            CHAT: `${API_BASE_URL}/chat/chat-with-codeskin`,
            GET_QUESTIONNAIRE: `${API_BASE_URL}/tools/get-full-questionnaire`,
            SUBMIT_RESULTS: `${API_BASE_URL}/tools/process-assessment-and-get-recommendations`,
            GET_SKIN_ANALYSIS: `${API_BASE_URL}/tools/get-skin-analysis-from-image`,
            UPLOAD_FACE_SCAN: `${API_BASE_URL}/tools/upload-face-scan`,
            DISPLAY_CHECK: `${API_BASE_URL}/tools/display-questionnaire-for-user`,
            GET_EXISTING_RECOMMENDATIONS: `${API_BASE_URL}/tools/get-existing-recommended-products`
        },

        // Widget specific constants
        SELECTORS: {
            WIDGET_ID: 'chatbot-widget',
            CONTAINER_ID: 'chatbot-content-container'
        },

        // Cache settings
        CACHE: {
            QUESTIONNAIRE_KEY: 'questionnaire_data',
            TTL: 24 * 60 * 60 * 1000 // 24 hours
        }
    };

    // Expose configuration globally
    window.ChatbotConfig = CONFIG;

})();
